import withLink from 'hoc/withLink';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import LottieView from 'lottie-react-native';
import { DimensionValue, Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice } from 'utils/index';

import LottieImage from 'assets/Lottie/playing.json';

import FastImage from 'components/FastImage';
import { Icons } from 'components/Icons';

const BoxedMediumCard: React.FC<CardProps> = ({ uri, title, subtitle, isPlaying, lines }) => {
  const textContainerWidth = useBreakpointValueGS({
    lg: 'auto',
    base: '80%',
  });

  return (
    <View style={[styles.card, { height: calcSizeForDevice(62) }]}>
      {!!uri && <FastImage source={{ uri }} style={styles.image} />}
      <View style={styles.contentRow}>
        <View style={[styles.textContainer, { width: textContainerWidth as DimensionValue }]}>
          {Boolean(title) && (
            <Text style={styles.title} numberOfLines={lines?.title || 2}>
              {title}
            </Text>
          )}
          {Boolean(subtitle) && (
            <Text style={styles.subtitle} numberOfLines={lines?.description || 1}>
              {subtitle}
            </Text>
          )}
        </View>
        <TouchableOpacity role="link" style={{ alignItems: 'center' }}>
          {isPlaying && Platform.OS !== 'web' ? (
            <LottieView
              autoPlay
              style={{
                width: 40,
                height: 40,
              }}
              source={LottieImage}
            />
          ) : (
            <Icons.ChevronRight
              color={theme.colors.base.button}
              width={calcSizeForDevice(24).toString()}
              height={calcSizeForDevice(24).toString()}
            />
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    backgroundColor: 'rgba(255,255,255,0.2)',
    marginBottom: calcSizeForDevice(20),
    borderRadius: 5,
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    height: '100%',
    width: calcSizeForDevice(64),
    borderRadius: 5,
  },
  contentRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: calcSizeForDevice(10),
  },
  textContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    color: 'white',
    fontSize: calcSizeForDevice(14),
    lineHeight: calcSizeForDevice(16),
    fontWeight: '700',
  },
  subtitle: {
    color: 'white',
    fontSize: calcSizeForDevice(11),
  },
});

export default withLink(BoxedMediumCard, 'BoxedMediumCard');
